import { render, staticRenderFns } from "./deductionRecord.vue?vue&type=template&id=0c7f3229&scoped=true"
import script from "./deductionRecord.vue?vue&type=script&lang=js"
export * from "./deductionRecord.vue?vue&type=script&lang=js"
import style0 from "./deductionRecord.vue?vue&type=style&index=0&id=0c7f3229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f3229",
  null
  
)

export default component.exports